import { render, staticRenderFns } from "./CheckBoxSwitch.vue?vue&type=template&id=05ed5064"
import script from "./CheckBoxSwitch.vue?vue&type=script&lang=ts"
export * from "./CheckBoxSwitch.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports